import { APP_INITIALIZER, ApplicationConfig, LOCALE_ID, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withDebugTracing, withViewTransitions } from '@angular/router';
import {provideHttpClient, withInterceptors, withXhr} from '@angular/common/http';

import {routes} from './app.routes';
import {provideTranslateService} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {BASE_AUTH_PATH} from './modules/auth/tokens';
import {KeycloakService, KeycloakConfig} from './modules/auth/keycloak.service';
import {AuthService} from './modules/auth/auth.service';
import {authInterceptor} from './modules/auth/auth.interceptor';
import {environment} from '../environments/environment';
import {provideNativeDateAdapter} from '@angular/material/core';
import { apiErrorInterceptor } from '@shared/interceptors/api-error.interceptor';

/** Fallback: used when the SSO FastAPI (/auth/config) is not reachable in dev. */
const KEYCLOAK_CONFIG: KeycloakConfig = {
    issuer: environment.KEYCLOAK_URL,
    realm: environment.KEYCLOAK_REALM,
    clientId: environment.KEYCLOAK_CLIENT_ID,
};

function keycloakInitializer(kc: KeycloakService, auth: AuthService) {
    return async () => {
        let authenticated = false;
        try {
            authenticated = await kc.init(KEYCLOAK_CONFIG);
        } catch (err) {
            console.error('[OSCE] Keycloak init failed, proceeding as unauthenticated', err);
        }
        auth.notifyAuthState(authenticated);
    };
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideNativeDateAdapter(),
        provideBrowserGlobalErrorListeners(),
        provideRouter(routes,
            // withViewTransitions(),
            // withDebugTracing()
        ),
        provideHttpClient(withXhr(), withInterceptors([
            authInterceptor,
            apiErrorInterceptor
        ])),
        {provide: LOCALE_ID, useValue: 'pl-PL' },
        provideTranslateService({
            loader: provideTranslateHttpLoader({
                prefix: '/assets/i18n/',
                suffix: '.json'
            }),
        }),
        {provide: BASE_AUTH_PATH, useValue: '/auth'},
        {
            provide: APP_INITIALIZER,
            useFactory: keycloakInitializer,
            deps: [KeycloakService, AuthService],
            multi: true,
        },
    ]
};

if (!environment.production && environment.keycloakCredentials) {
    appConfig['providers'].push({
        provide: KeycloakService,
        useValue: {
            init: () => {},
            isLoggedIn: true,
            getValidToken: async () => (environment.keycloakCredentials as any).token
        },
    })
}

